import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CustomSelect from "../../../common/interactive/CustomSelect";
import { caseActions } from "../../../../store/case";
import { caseQuickUpdate } from "../../../../lib/fetchApi";
import { notificationActions } from "../../../../store/notifications";
import NegotiationEntityItem from "./NegotiationEntityItem";
import { returnRepresentativeTypeFromEntity } from "../../../../lib/misc";
import { getNegotiatorType } from "../../../../lib/systemData";

export default function NegotiationEntity({primaryAttorney}) {

    const dispatch = useDispatch() 
    const activeCase = useSelector(state => state.case.activeCase) 
    const userToken = useSelector(state => state.user.token)

    // const [entityType, setEntityType] = useState(activeCase.case_negotiation?.entity_type)
    const [entityType, setEntityType] = useState(primaryAttorney.negotiator_type)

    // const [negotiatorOptions, setNegotiatorOptions] = useState(null)
    const [sendIsLoading, setSendIsLoading] = useState(false)

    async function directlySetANegotiator(entityType, id) {
        setSendIsLoading(true)
        let reqBody = {
            type: `case_negotiation`,
            fields: {
                entity_type: entityType,
                entity_type_id: id
            }
        }     

        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {            
            dispatch(notificationActions.setError(update))
        } else {
            

            dispatch(caseActions.replaceWholeFolder({
                folder: 'case_negotiation',
                content: update
            }))     
        } 
        setSendIsLoading(false)
    }

    // const [reps, setReps] = useState(null)
    const updateNegotiatorTypeHandler = async (data) => {
        setEntityType(data.data.value)      
    
        if (data.data.value == 'App\\Models\\Negotiator' && primaryAttorney.all_reps.negotiators && primaryAttorney.all_reps.negotiators.length == 1) {
            // directly select the only one 
            directlySetANegotiator(data.data.value, primaryAttorney.all_reps.negotiators[0].id)
        } 
        if (data.data.value == 'App\\Models\\CaseManager' && primaryAttorney.all_reps.case_managers && primaryAttorney.all_reps.case_managers.length == 1) {
            // directly select the only one 
            directlySetANegotiator(data.data.value, primaryAttorney.all_reps.case_managers[0].id)
        } 
        if (data.data.value == 'App\\Models\\Attorney' && primaryAttorney.all_reps.attorneys && primaryAttorney.all_reps.attorneys.length == 1) {
            // directly select the only one 
            directlySetANegotiator(data.data.value, primaryAttorney.all_reps.attorneys[0].id)
        } 
    }

    useEffect(() => {
        setEntityType(primaryAttorney.negotiator_type)
    }, [primaryAttorney.negotiator_type])


    return <>
        <CustomSelect action={updateNegotiatorTypeHandler} label={'Negotiator'} optionsData={getNegotiatorType()} preSelectedValue={entityType} identifier={{type: 'case_negotiation'}}/>
        <NegotiationEntityItem primaryAttorney={primaryAttorney} entityType={entityType} sendIsLoading={sendIsLoading} reps={returnRepresentativeTypeFromEntity(entityType)}/>        
    </>
}